import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
import Modal from './modal_doc_perusahaan';
import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

const title_form = "DATA PERUSAHAAN / GROUP";
const sub_title_form = ""
const tipedata = "PERUSAHAAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const hostcc = process.env.REACT_APP_API_HOST_COLOR_COMMENT;
const hostdrop = process.env.REACT_APP_API_HOST_DROPDOWN;
const hostdatcont = process.env.REACT_APP_API_HOST_DATA_CONT;

const API_COLUMN = mainhost + "PerusahaanColumn"
const API_VALUES = mainhost + "PerusahaanValue"
const API_Asset = mainhost + "AssetData"
const API_NewAsset = mainhost + "AssetNew"
const API_ActiveAsset = mainhost + "AssetActive"
const API_PercentAsset = mainhost + "AssetPercent"
const API_CREATE_ID = mainhost + "PerusahaanValue/New"
const API_STATUS_FILE = mainhost + "Cekstatusfile"
const API_UPDATE_COMMENT = hostcc + "Updatecomment"
const API_UPDATE_WARNA = hostcc + "ColorBrcontainers"
const API_UPDATE = mainhost + "PerusahaanValue_update"
const API_PASTE = mainhost + "PerusahaanForPaste"
const API_PT_DROPDOWN = mainhost + "PerusahaanForDropdown"

const currentUrl = window.location.href;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const Asset = () => {
  const token = localStorage.getItem('token');

  const [TokenNew, setToken] = useState(null);
  const [AssetData, setAssetData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const config = apiConfig(token);


  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  const getAssetData = async () => {
    try {

      const formData = new FormData();
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_Asset}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleNewAsset = async () => {
    const newAsset = document.getElementById('new_asset').value;
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('asset', newAsset);
      const response = await axios.post(`${API_NewAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
      const asset_data = await getAssetData();
      setAssetData(asset_data);
      setIsLoading(false);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleActiveAsset = async (id) => {
    setIsLoading(true);
    AssetData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.active);
        if (item.active === '1') {
          item.active = '0';
        }
        else {
          item.active = '1';
        }
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      const response = await axios.post(`${API_ActiveAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handlePercentAsset = async (id,e) => {
    console.log(e.target.value);
    console.log(id);
    setIsLoading(true);
    AssetData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.percentage);
        item.percentage = e.target.value;
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('percentage', e.target.value);
      const response = await axios.post(`${API_PercentAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    // const intervalId = setInterval(cekFile, 3600000);//1 jam

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      const asset_data = await getAssetData();
      console.log(asset_data);
      setAssetData(asset_data);
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;
      console.log('asset',AssetData);
      // if (totaldata > 0) {
      //   var total_data = luckysheet.getAllSheets()[0].data.length;
      //   calcChainLength = total_data + 1;
      //   // luckysheet.setBothFrozen(true, { range: { row_focus: 0, column_focus: end_column_freze } });
      //   // helperFilter(11);
      //   // const mobileScreenWidth = 768;
      //   // if (window.innerWidth > mobileScreenWidth){
      //   //   luckysheet.setSheetZoom(defaultratio);
      //   // }
      //   setleftScrollbarstart();
      // }

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const labelStyel = {
    marginTop: '22px',
  };
  return (
    <div>
      <HeaderMenu title={"Asset"} subtitle={"Asset"} />
      <ToastContainer />
      <div style={{ textAlign: 'center', overflow:'auto', height:'540px'}}>
        <table border={0}>
          <thead>
            <tr>
              <th>Asset</th>
              <th><input type="text" id="new_asset" placeholder="newasset" /></th>
              <th><button onClick={handleNewAsset} >New Asset</button></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Asset</th>
              <th>Toko</th>
              <th>Active</th>
              <th>Percentage</th>
            </tr>
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              AssetData.map((item) => (
                <tr key={item.id}>
                  <td>{item.asset}</td>
                  <td>{item.toko}</td>
                  <td><input type="checkbox" onChange={() => handleActiveAsset(item.id)} defaultValue={item.active} checked={item.active === '1'} /></td>
                  <td><input type="number" defaultValue={item.percentage} onBlur={(e) => handlePercentAsset(item.id,e)}  /></td>
                </tr>
              ))
            )}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default Asset;